import { createContext } from 'react';
import { InitialAuthState } from './const';

export const AuthContext = createContext(InitialAuthState);
